 <template>
  <div class="aiChat" ref="modal"  :style="{'width':width,'height':height}">
    <header>
      <a-row type="flex" style="height: 100%;" >
        <a-col flex="auto">
          <div class="displayContetn headerTitle" style="justify-content: flex-start;" @mousedown="startDrag">
            AI助手
          </div>
        </a-col>
         <a-col flex="40px">
          <div class="displayContetn headerTitle" style="font-size: 36px;cursor: pointer;" @click.stop="newChat">
            <a-icon type="delete" :style="{ fontSize: '20px', lineHeight: '60px'}"></a-icon>
          </div>
        </a-col>
        <a-col flex="40px">
          <div class="displayContetn headerTitle" style="font-size: 36px;cursor: pointer;" @click.stop="toggleFullScreen">
            <a-icon :type="width=='400px'?'fullscreen':'fullscreen-exit'" :style="{ fontSize: '20px', lineHeight: '60px'}"></a-icon>
          </div>
        </a-col>
        <a-col flex="40px">
          <div class="displayContetn headerTitle" style="font-size: 36px;cursor: pointer;" @click.stop="$emit('closeFn')">
            <a-icon type="close" :style="{ fontSize: '20px', lineHeight: '60px'}"></a-icon>
          </div>
        </a-col>
      </a-row>
    </header>
    <ul class="chatUlBox" ref="chatContainer" >
      <h2 class="tipsBox" v-if="!$store.state.user.info">请登录后使用</h2>
      <p class="tipsBox" v-else-if="chatsMessage.length == 0">暂无消息</p>
      <li v-for="item,index in chatsMessage" :key="index" class="mesageList" v-show="chatsMessage.length > 0">
        <div class="avatar" :style="{float:item.Location}">
          <a-avatar shape="square" :src="item.avatar" />
        </div>
        <div class="content"  :style="{float:item.Location,'align-items':item.Location == 'right' ? 'end' : 'start'}">
          <p v-if="item.Location == 'left'" class="contentInfo">{{ item.author }} &nbsp;&nbsp;{{ item.datatime }}</p>
          <p v-if="item.Location == 'right'" class="contentInfo">{{ item.datatime }} &nbsp;&nbsp;{{ item.author }}</p>
          <pre class="contentMsg">{{ formatMessage(item.content) }}</pre>
        </div>
      </li>
    </ul>
    <footer>
      <a-row style="height: 73px; margin-top: 10px;">
        <a-col :span="19">
          <a-textarea class="chatTextarea" v-model="content" :autosize="{ minRows: 3, maxRows: 3 }" @pressEnter.stop="send" style="max-height: 73px;" placeholder="请输入要咨询的问题" allow-clear />
        </a-col>
        <a-col :span="5" class="displayContetn" >
          <a-button style="height:64px;width:64px;" type="primary" :disabled="!canSend || content==''" @click="send">发送</a-button>
        </a-col>
      </a-row>  
    </footer>
  </div>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"
import { getAction } from "@/api/manage";
import moment from 'dayjs'

const token = Vue.ls.get(ACCESS_TOKEN)
export default {
  name: "AIChat",
  props: {
    //显示问题
    showQuestion: {
      type: Boolean,
      default: true
    },
    //是否可以回复
    reply: {
      type: Boolean,
      default: false
    },
    // 自定义机器人名字
    robotName: {
      type: String,
      default: 'AI助手'
    },
    //自定义机器人头像
    robotAvatar: {
      type: String,
      default: '/logo.png'
    },
    viewWidth:{
      type:Number,
      default:400
    },
    viewHeight:{
      type:Number,
      default:500
    }
  },
  data() {
    return {
      pendingMsg: '', //正在接受的消息
      lastStatus: 2, //上一次的对话状态
      chatsMessage: [], //对话列表
      chatConfig: null,
      chat: "",
      content: "",
      canSend: false,
      startX: 0,
      startY: 0,
      dragging: false,
      width:'400px',
      height:'500px'
    };
  },
  computed: {
    avatarUrl() {
      if (this.$store.state.user && this.$store.state.user.avatar) {
        return this.$store.state.user.avatar
      } else if (this.$store.state.user && this.$store.state.user.info && this.$store.state.user.info.avatar) {
        return this.$store.state.user.info.avatar
      } else {
        return "/img/avatar.png"
      }
    }
  },

  created() {
    if(this.$store.state.user.info){
      this.getAIChat();
    }
    this.username = this.$store.state.user.info.realname || this.$store.state.user.info.username
  },
  methods: {
    startDrag(e) {
      this.dragging = true;
      this.startX = e.clientX - this.$refs.modal.offsetLeft;
      this.startY = e.clientY - this.$refs.modal.offsetTop;
      document.addEventListener('mousemove', this.drag);
      document.addEventListener('mouseup', this.stopDrag);
    },
    drag(e) {
      if (this.dragging) {
        const viewWidth = window.innerWidth*1 - this.viewWidthNum
        const viewHeight = window.innerHeight*1 - this.viewHeightNum
        const x = (e.clientX - this.startX) > viewWidth ? viewWidth : ( e.clientX - this.startX ) > 0 ? (e.clientX - this.startX) :  0 ;
        const y = (e.clientY - this.startY) > viewHeight ? viewHeight :(e.clientY - this.startY) > 0 ? e.clientY - this.startY : 0;
        this.$refs.modal.style.left = `${x}px`;
        this.$refs.modal.style.top = `${y}px`;
      }
    },
    stopDrag() {
      this.dragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);
    },
    toggleFullScreen(){
      if(this.width == '400px'){
        this.width = '100%';
        this.height = '100%'
      }else{
        this.width = '400px'
        this.height = '500px'
      }
    },
    send() {
      let that = this
      let myMsg = {
        author: this.username,
        avatar: this.avatarUrl,
        content: this.content,
        datatime: moment().format('YYYY-MM-DD hh:mm:ss'),
        Location: 'right'
      }
      this.chatsMessage.push(myMsg)
      this.websocketSend(this.getPayload(this.content));
      this.content = "";
      this.canSend = false
      this.scrollToBottom()

      //5s超时后也允许发送
      setTimeout(function(){
        that.canSend = true
      }, 5000)
    },
    // 重新开始对话
    newChat(){
      if(this.chatsMessage.length > 0 && confirm('是否开启新的对话？')){
        this.chatsMessage = []
        let payload = {
          token: token,
          cmd: "clear"
        }
        this.websocketSend(JSON.stringify(payload));
        this.scrollToBottom()
      }
    },
    getAIChat() {
      // getAction("/common/utils/getAIChat").then((res) => {
      //   if (res.success) {
      //     if(window.location.protocol == 'https:'){
      //       res.result.url = res.result.url.replace('ws:','wss:')
      //     }
      //     this.chatConfig = res.result;
      //     this.initWebSocket();
      //   }
      // });
      this.chatConfig = {
        url: 'ws://' + location.host + '/api/websocket/ai/chat'
      }
      if(window.location.protocol == 'https:'){
        this.chatConfig.url = this.chatConfig.url.replace('ws:','wss:')
      }
      this.initWebSocket();
    },
    scrollToBottom() {
      const chatContainer = this.$refs.chatContainer
      chatContainer.scrollTop = chatContainer.scrollHeight;
    },
    // getPayload(text) {
    //   if (text.length > 8000) {
    //     alert("消息太长");
    //     return;
    //   }
    //   let payload = {
    //     header: this.chatConfig.header,
    //     parameter: this.chatConfig.parameter,
    //     payload: {
    //       message: {
    //         text: [{ role: "user", content: text }],
    //       },
    //     },
    //   };
    //   return JSON.stringify(payload);
    // },
    getPayload(text){
      if (text.length > 8000) {
        alert("消息太长");
        return;
      }
      let payload = {
        token: token,
        msg: text
      }
      return JSON.stringify(payload)
    },
    formatMessage(text){
      return text
    },

    //ws消息回调
    exeCallback(data) {
      console.log(data);
      // if (data.header.code == 0) {
      //   if (data.payload.choices.status == 0) {
      //     let myMsg = {
      //       author: this.robotName,
      //       avatar: this.robotAvatar,
      //       content: '',
      //       datatime: moment().format('h:mm:ss'),
      //       Location: 'left'
      //     }
      //     this.chatsMessage.push(myMsg)
      //   }
      //   this.chatsMessage[this.chatsMessage.length - 1]['content'] += data.payload.choices.text[0].content
      //   console.log(this.chatsMessage, '聊天记录')
      //   this.scrollToBottom()
      //   if (data.payload.choices.status == 2) {
      //     this.canSend = true
      //   }
      // }

      // let data = JSON.parse(data)
      if(data.state == 0 || this.lastStatus == 2){
        let myMsg = {
            author: data.role == 'user' ? this.username : this.robotName,
            avatar: data.role == 'user' ? this.avatarUrl : this.robotAvatar,
            content: '',
            datatime: moment().format('YYYY-MM-DD HH:mm:ss'),
            Location: data.role == 'user' ? 'right' : 'left'
          }
          this.chatsMessage.push(myMsg)
          this.pendingMsg = ''
      }
      this.pendingMsg += data.msg
      this.chatsMessage[this.chatsMessage.length - 1]['content'] = this.pendingMsg
      
      //对话完毕
      if(data.status == 2){
        this.canSend = true
      }
      this.lastStatus = data.status
      this.scrollToBottom()
    },
    onWsOpen() {
      let payload = {
        token: token,
        cmd: "history"
      }
      this.websocketSend(JSON.stringify(payload));
      this.canSend = true
    },

    ////////////websocket///////////
    initWebSocket: function () {
      console.log("------------WebSocket连接成功");
      this.websock = new WebSocket(this.chatConfig.url);
      this.websock.onopen = this.websocketOnopen;
      this.websock.onerror = this.websocketOnerror;
      this.websock.onmessage = this.websocketOnmessage;
      this.websock.onclose = this.websocketOnclose;
    },
    websocketOnopen: function () {
      this.isWsConnect = true;
      this.onWsOpen();
    },
    websocketOnerror: function (e) {
      console.log("WebSocket连接发生错误", e);
      this.reconnect();
    },
    websocketOnclose: function (e) {
      this.isWsConnect = false;
      this.reconnect();
    },
    websocketSend(text) {
      // 数据发送
      try {
        this.websock.send(text);
      } catch (err) {
        console.log("send failed (" + err.code + ")");
      }
    },
    websocketOnmessage(e) {
      let data = JSON.parse(e.data);
      this.exeCallback(data);
    },
    reconnect() {
      var that = this;
      if (that.lockReconnect) return;
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      setTimeout(function () {
        console.info("尝试重连...");
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    /////////////////////////////////////
  },
};
</script>

<style lang="less" scoped>
.displayContetn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.aiChat {
  background: #fff;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 99;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 3px 0px #00000073;
  /deep/.ant-list{
    width: 100%;
    height: 100%;
  }

  header {
    width: 100%;
    height: 60px;
    padding: 0 20px;
    background: rgb(31, 150, 247);
    cursor: pointer;

    .headerTitle {
      height: 100%;
      line-height: 60px;
      color: #fff;
      font-size: 16px;
    }
  }
  .chatUlBox{
    height: calc(100% - 197px) !important;
    width: 100% !important;
    overflow-y: auto;
    padding-inline-start: 0px;
    .tipsBox{
      width: 100%;
      font-size: 16px;
      color: #999;
      text-align: center;
      padding: 30px 0;
    }
    .mesageList {
      width: 100%;
      height: auto;
      padding: 10px;
      overflow: hidden;
      .avatar{
        margin: 0 10px;
      }
      .content{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: end;
        width: calc(100% - 55px);
        .contentInfo{
          font-size: 12px;
          color: #666;
        }
        .contentMsg{
          width: auto;
          height: auto;
          text-wrap: pretty;
          margin-top: 8px;
          font-size: 14px;
          color: #666;
          padding: 5px 10px;
          background: rgb(223, 245, 255);
          border-radius: 5px;
        }
      }
    }
  }


  footer {
    width: 100%;
    height: 136px;
    padding: 10px 20px;
    background: #fff;
    border-top: 1px solid #ccc;
  }
}
</style>